import { createAction } from "@reduxjs/toolkit";
import {
  ICampaignLeadGetType,
  ICampaignLeadLogTableType,
  IDispositionForm,
} from "../../types/campaignTypes";

export const getCampaignLeadData = createAction<ICampaignLeadGetType>(
  "campaign/getCampaignLeadData"
);
export const getCampaignLeadLogTable = createAction<ICampaignLeadLogTableType>(
  "campaign/getCampaignLeadLogTable"
);

export const addCampaignLeadDisposition = createAction<IDispositionForm>(
  "campaign/addCampaignLeadDisposition"
);
